export default {
  EP_MAILRU: "mailru",
  EP_OK: "ok",
  EP_VK: "vk",
  EP_FB: "fb",
  EP_TWITTER: "tw",
  EP_STEAM: "steam",
  EP_GOOGLE: "g",
  EP_TWITCH: "twitch",
  EP_XBOX: "xbox",
  EP_PLAYSTATION: "ps",
  EP_NINTENDO: "ns",
  EP_EPICGAMES: "eg",
  EP_APPLE: "apple",
};
